<template>
    <rkm-overlay>
        <rkm-layout-body title="Confirmação de Consulta">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/ambulatorio/confirmacao-consulta/List'

export default {
    components: { List },
}
</script>
